module.exports = __webpack_public_path__ + "img/add-new-white.88fcb3a0.svg";